import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-border-icon',
  templateUrl: './design-border.component.html'
})
export class DesignBorderComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
